<template>
    <v-card outlined class="mb-6" color="blue-grey lighten-5">
      <v-card-text>
        <v-row align="center" no-gutters>
          <v-col cols="12" class="px-2 mb-4">
            <h2 class="mb-6">Billing Timer</h2>
            <AutoCompleteCrudAdvanced table="services" label="Service Description" @input="getSelectedService"></AutoCompleteCrudAdvanced>
            <!-- <v-select
              v-model="selectedService"
              :items="serviceRates"
              item-text="name"
              return-object
              label="Service Type"
              outlined
              dense
              hide-details
              :disabled="isRunning || isPaused"
            ></v-select> -->
          </v-col>
  
          <v-col cols="12" class="text-center px-2 mb-4">
            <div :class="isRunning ? 'primary--text' : (isPaused ? 'warning--text' : 'grey--text text--darken-3')" 
                 class="display-1 font-weight-black">
              {{ formattedTime }}
            </div>
            <div class="caption text-uppercase font-weight-bold">
              {{ isPaused ? 'Timer Paused' : (isRunning ? 'Timer Running' : 'Timer Ready') }}
            </div>
          </v-col>
  
          <v-col cols="12" class="text-center px-2 mb-4 d-flex justify-space-between">
            <v-btn v-if="!isRunning" color="primary" @click="startTimer" width="48%">
              <v-icon left>{{ isPaused ? 'mdi-play-pause' : 'mdi-play' }}</v-icon>
              {{ isPaused ? 'Resume' : 'Start' }}
            </v-btn>
  
            <v-btn v-if="isRunning" color="warning" @click="pauseTimer" width="48%">
              <v-icon left>mdi-pause</v-icon> Pause
            </v-btn>
  
            <v-btn :disabled="!isRunning && !isPaused" color="error" @click="stopTimer" width="48%">
              <v-icon left>mdi-stop</v-icon> Stop
            </v-btn>
          </v-col>
  
          <v-col cols="12" class="mb-4" v-if="!isRunning && !isPaused && seconds > 0">
                
                  <v-btn @click="resetTimer"  color="brown" dark>Reset</v-btn> 

                  <v-btn @click="prepareBilling('pro-bono')"  color="purple" dark class="mx-1">Pro-Bono</v-btn>

                  <v-btn @click="prepareBilling('bill')"  color="teal" dark>Bill Item</v-btn>  
          </v-col>
        </v-row>
      </v-card-text>
  
      <v-expand-transition>
        <div v-if="tempEntry" class="white pa-4 border-top">
          <v-row align="center">
            <v-col cols="12" md="7">
              <v-text-field 
                v-model="tempEntry.name" 
                label="Description for Ledger" 
                hide-details 
                outlined 
                dense
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="text-right headline font-weight-bold">
              {{ formatCurrency(tempEntry.price) }}
            </v-col>
            <v-col cols="12" md="2">
              <v-btn color="success" block @click="confirmBilling">Add to Ledger</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
    </v-card>
  </template>
  
  <script>
  import helpersJs from "@/plugins/helpers"
  import AutoCompleteCrudAdvanced from "@/modules/CrudDatabases/AutoCompleteCrudAdvanced.vue"

  export default {
    name: 'BillingTimer',
    components:{AutoCompleteCrudAdvanced},
    data() {
      return {
        isRunning: false,
        isPaused: false,
        seconds: 0,
        timerInterval: null,
        selectedService: null,
        tempEntry: null
      };
    },
    computed: {
      formattedTime: function() {
        var h = Math.floor(this.seconds / 3600);
        var m = Math.floor((this.seconds % 3600) / 60);
        var s = this.seconds % 60;
        return (
          (h < 10 ? "0" + h : h) + ":" + 
          (m < 10 ? "0" + m : m) + ":" + 
          (s < 10 ? "0" + s : s)
        );
      },
      getCurrency(){
        return this.$store.getters.getCurrency
      }
    },
    methods: {
      getSelectedService(selectedService){
        this.selectedService = selectedService
      },
        formatCurrency: function(val) {
            return this.getCurrency + helpersJs.formatMoney(val)
      },
      startTimer: function() {
        if(!this.selectedService){
          this.$toast.info("Select or Add New Item  to Bill", {duration: 10000})
          return;
        }
        var self = this;
        this.isRunning = true;
        this.isPaused = false;
        this.tempEntry = null; // Clear any pending confirmation
        this.timerInterval = setInterval(function() {
          self.seconds++;
        }, 1000);
      },
      pauseTimer: function() {
        this.isRunning = false;
        this.isPaused = true;
        clearInterval(this.timerInterval);
      },
      stopTimer: function() {
        this.isRunning = false;
        this.isPaused = false;
        clearInterval(this.timerInterval);
      },
      resetTimer: function() {
        this.stopTimer();
        this.seconds = 0;
        this.tempEntry = null;
      },
      prepareBilling: function(mode) {
        // Calculate decimal hours (seconds / 3600)
        var hours = this.seconds / 3600;
        var rate = (mode === 'bill') ? Number(this.selectedService.price) : 0;
        
        this.tempEntry = {
          tax_amount: mode === 'bill' ? (hours * rate * 0.15).toFixed(2) : 0,
          category_id:this.selectedService.category_id,
          description: this.selectedService.description || 'Fee',
          date: new Date().toISOString().substr(0, 10),
          name: this.selectedService.name + " (" + this.formattedTime + ")",
          price: hours * rate,
          isVatable: (mode === 'bill'),
          rawSeconds: this.seconds // Helpful for total time analytics
        };
      },
      confirmBilling: function() {
        
        // Emit the event to CaseFile.vue
        this.$emit('add-to-ledger', this.tempEntry);
        this.resetTimer();
      },
      
    },
    beforeDestroy: function() {
      // Safety cleanup
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
    }
  };
  </script>
  
  <style scoped>
  .border-top { border-top: 2px solid #e0e0e0; }
  </style>